import InlineLinks from './InlineLinks';

interface CalloutProps {
  title: string;
  description: string;
}

function InfoIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9" fill="#4169FF" />
      <rect x="9" y="5.5" width="2" height="2" rx="1" fill="white" />
      <rect x="9" y="9" width="2" height="5.5" rx="1" fill="white" />
    </svg>
  );
}

export default function Callout({ title, description }: CalloutProps) {
  return (
    <div className="flex w-full flex-col items-start rounded-[24px] bg-[#f0f6ff] py-2">
      <div className="flex w-full items-center gap-[6px] px-5 py-2">
        <InfoIcon />
        <p className="flex-1 text-base font-bold leading-[1.5] text-gray-100">
          <InlineLinks text={title} />
        </p>
      </div>
      <div className="w-full px-5 pb-2 pt-1">
        <p className="whitespace-pre-line text-base font-normal leading-[1.5] text-gray-80">
          <InlineLinks text={description} />
        </p>
      </div>
    </div>
  );
}
